import React from 'react'
import ReactDOM from 'react-dom'
import {connect} from 'react-redux'

import intersection from 'lodash/intersection'

import sendNewMessage from '../data/setters/send_new_message'
import requestSignin from '../data/actions/request_signin'

class ConversationActions extends React.Component {
  constructor (props) {
    super(props)

    this.state = {}
  }


  componentDidMount () {
    this.focusInputElement()
  }

  componentDidUpdate (prevProps) {
    const {lastOpenTime: prevLastOpenTime} = prevProps
    const {lastOpenTime} = this.props

    if ((!prevLastOpenTime && lastOpenTime) || (lastOpenTime > prevLastOpenTime)) {
      this.focusInputElement()
    }
  }

  focusInputElement () {
    const inputDOM = ReactDOM.findDOMNode(this.refs.input)
    if (inputDOM) setTimeout(() => inputDOM.focus(), 0)
  }

  doesIncludeStopWord (message) {
    if (!this.props.stopWords) return false
    if (this.props.stopWords.length === 0) return false

    let messageWordsArr = message.replace(/\W+/g, ' ').match(/[^ ]+/g)
    let stopWordsArr = this.props.stopWords.split(/\,\s+/g)

    if (intersection(stopWordsArr, messageWordsArr).length > 0) {
      return true
    }

    return false
  }

  shouldShowSigninAction () {
    if (!this.props.currentUser) return true
  }

  canTypeNewMessage () {
    if (!this.props.currentUser) return false
    if (!this.props.to && !this.props.otherUser) return false
    if (!this.props.isActive) return false

    return true
  }

  onInputBlur () {
    if (this.props.onNewMessageInputBlur) this.props.onNewMessageInputBlur()
  }

  onInputFocus () {
    if (this.props.onNewMessageInputFocus) this.props.onNewMessageInputFocus()
  }

  onNewMessage (event) {
    if (event.key === 'Enter' && this.refs.input.value.length > 0) {
      let message = this.refs.input.value

      if (this.doesIncludeStopWord(message)) {
        this.setState({shouldShowStopWordInformer: true})
      }
      else {
        this.setState({shouldShowStopWordInformer: false})

        const from = this.props.currentUser.get('uid')
        const role = this.props.currentUser.get('role')
        const to = this.props.to || this.props.otherUser.get('uid')
        const containerId = this.props.conversationContainerId

        this.props.onNewMessage(message, containerId, from, to, this.props.shouldSendNotification, this.props.messageType, role)

        this.refs.input.value = ''
      }
    }
  }

  renderSignInAction () {
    return (
      <div className='signin-action-content' onClick={this.props.requestSignin}>
        <span style={{textDecoration: 'underline'}}>Sign in</span> to chat.
      </div>
    )
  }

  renderTypeInformer () {
    if (this.state.shouldShowStopWordInformer) {
      return (
        <div className='type-informer'>
          You have used a banned word. Please remove it.
        </div>
      )
    }
  }

  renderInnerContent () {
    return (
      <input type='text'
        ref='input'
        className='conversation-message-input'
        placeholder='Type your message'
        onBlur={this.onInputBlur.bind(this)}
        onFocus={this.onInputFocus.bind(this)}
        onKeyDown={this.onNewMessage.bind(this)} />
    )
  }

  render () {
    if (this.shouldShowSigninAction()) {
      return (
        <div ref='conversationActions' className='conversation-actions signin' style={{height: this.props.height}}>
          {this.renderSignInAction()}
        </div>
      )
    }
    if (this.props.warningMessage) {
      return (
        <div ref='conversationActions' className='conversation-actions warning' style={{height: this.props.height}}>
          {this.props.warningMessage}
        </div>
      )
    }
    if (this.canTypeNewMessage()) {
      return (
        <div ref='conversationActions' className='conversation-actions' style={{height: this.props.height}}>
          {this.renderTypeInformer()}
          {this.renderInnerContent()}
        </div>
      )
    }
    else {
      return (
        <div ref='conversationActions' className='conversation-actions disabled' style={{height: this.props.height}}/>
      )
    }
  }
}

ConversationActions.defaultProps = {
  height: 41
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.get('currentUser'),
    stopWords: state.getIn(['chatSettings', 'stopWords']),
    lastOpenTime: state.getIn(['conversations', '_lastOpenTimes', ownProps.conversationContainerId])
  }
}

const mapDispatchToProps = () => {
  return {
    onNewMessage: sendNewMessage,
    requestSignin: requestSignin
  }
}

const ConversationActionsContainer = connect(
  mapStateToProps, mapDispatchToProps
)(ConversationActions)

export default ConversationActionsContainer



/** WEBPACK FOOTER **
 ** ./modules/shared/conversation/actions.js
 **/